// extracted by mini-css-extract-plugin
export default {"filtersContainer":"student-filters_filtersContainer__YxPgA","dropdownContainer":"student-filters_dropdownContainer__VO8M0","marginRight10":"student-filters_marginRight10__BJu5O"};